import { Skeleton } from '@/components/atoms/Skeleton';
import FallbackSideContainerDesktop from '@/components/organisms/FallbackSideContainersDesktop';
import { breakpointDesktopDefault } from '@/hooks/useBreakpoint';
import { theme } from '@/styles/theme';

export default function SacolaDesktopFallback() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing[6],
        gap: theme.spacing[5],
        ...breakpointDesktopDefault,
      }}
    >
      <Skeleton style={{ width: '10vw', height: 32 }} />
      <FallbackSideContainerDesktop />
    </div>
  );
}
